import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/config";

export default function Header() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [active, setActive] = useState("home");

    useEffect(() => {
        const onScroll = () => {
            setScrolled(window.scrollY > 10);
            const pos = window.scrollY + 140;
            let current = "home";
            NAV_LINKS.forEach(({ href }) => {
                const el = document.getElementById(href.slice(1));
                if (el && el.offsetTop <= pos) current = href.slice(1);
            });
            setActive(current);
        };
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("lenis:navigate", onScroll);
        return () => {
            window.removeEventListener("scroll", onScroll);
            window.removeEventListener("lenis:navigate", onScroll);
        };
    }, []);

    return (
        <header
            className={`fixed inset-x-0 top-0 z-50 bg-[#F5ECDD]/95 backdrop-blur-md border-b border-burgundy/10 transition-shadow duration-300 ${
                scrolled ? "shadow-[0_10px_30px_-18px_rgba(90,0,16,0.35)]" : ""
            }`}
            data-testid="site-header"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="flex items-center justify-between h-[76px]">
                    <a href="#home" data-testid="nav-logo">
                        <img
                            src="/analytrova-logo.jpg"
                            alt="Analytrova"
                            className="h-11 sm:h-12 w-auto"
                        />
                    </a>

                    {/* Desktop nav */}
                    <nav className="hidden lg:flex items-center gap-8">
                        {NAV_LINKS.map((l) => {
                            const id = l.href.slice(1);
                            return (
                                <a
                                    key={l.href}
                                    href={l.href}
                                    onClick={() => setActive(id)}
                                    className={`nav-link text-[15px] transition-all duration-300 ${
                                        active === id
                                            ? "active text-burgundy font-semibold"
                                            : "text-charcoal/80 hover:text-burgundy"
                                    }`}
                                    data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
                                >
                                    {l.label}
                                </a>
                            );
                        })}
                    </nav>

                    <button
                        className="lg:hidden inline-flex items-center justify-center w-11 h-11 rounded-full border border-burgundy/20 text-burgundy"
                        onClick={() => setOpen(!open)}
                        aria-label="Toggle menu"
                        data-testid="nav-mobile-toggle"
                    >
                        {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                    </button>
                </div>
            </div>

            {/* Mobile menu */}
            <div
                className={`lg:hidden overflow-hidden border-t border-burgundy/10 bg-[#F5ECDD] transition-all duration-500 ${
                    open ? "max-h-[480px]" : "max-h-0 border-t-0"
                }`}
                data-testid="nav-mobile-menu"
            >
                <nav className="px-6 py-6 flex flex-col gap-1">
                    {NAV_LINKS.map((l) => {
                        const id = l.href.slice(1);
                        return (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={() => {
                                    setOpen(false);
                                    setActive(id);
                                }}
                                className={`py-3 text-lg border-b border-burgundy/8 transition-colors ${
                                    active === id
                                        ? "text-burgundy font-semibold"
                                        : "text-charcoal/85 hover:text-burgundy"
                                }`}
                                data-testid={`nav-mobile-${l.label.toLowerCase().replace(" ", "-")}`}
                            >
                                {l.label}
                            </a>
                        );
                    })}
                </nav>
            </div>
        </header>
    );
}
